import styled from "styled-components";
import { Fab, Tooltip } from "@material-ui/core";
import theme from "@src/Tools/MuiTheme";
import { green } from "@material-ui/core/colors";
import React from "react";
import { FabProps } from "@material-ui/core/Fab";
import { Values } from "@src/Tools/Values";

export const STFab = styled(Fab)`
  && {
    transform: scale(0.8);
    border-radius: 50%;
  }
`;

export const STFabGreen = styled(STFab)`
  && {
    margin: ${theme.spacing(1)}px;
    background-color: ${green[500]};
    color: #fafafa;
    border-radius: 50%;
    :hover {
      background-color: ${green[700]};
    }
  }
`;

export const STFabGreenAdd = ({ children, ...rest }: FabProps) => (
  <Tooltip title={Values.getLocalizationValue("add")} placement="top">
    <STFabGreen {...rest}>{children}</STFabGreen>
  </Tooltip>
);

interface IProps extends FabProps {
  tooltipTitle: string;
}

export const STFabTooltip = ({ tooltipTitle, children, ...rest }: IProps) => (
  <Tooltip title={tooltipTitle} placement="top">
    <STFab {...rest}>{children}</STFab>
  </Tooltip>
);
